import {
	Component,
	Input,
	SimpleChange,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import { GenTableDisplayComponent } from "@app/gen-table-display/gen-table-display.component"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { Modalable } from "@app/Modalable"

@Component({
	selector: "app-choose-person",
	imports: [
		COMMON_IMPORTS,
		GenAutocompleteComponent,
		ModalWrapComponent,
		GenTableDisplayComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div>
			<app-gen-autocomplete
				#searchFuzzy
				title_ph_lang="patients_plus"
				[fuzzySearchableClasses]="
					permsService?.perms?.administrative
						? ['patients', 'contacts', 'payors']
						: ['patients', 'contacts']
				"
				(chosenEvent)="handleChoose($event)"
				[searchableFields]="['name', 'id_number']"
				optionDisplay="%name% %id_number%"
			/>
		</div>
		@if (modalProps) {
			<app-modal-wrap
				(onClose)="modalProps = null"
				title="contactways"
				modalWrapperClass="modal-800"
			>
				<app-gen-table-display
					(onClose)="modalProps = null; $event?.length && onClose.emit($event)"
					tableName="contactways"
					[filterField]="modalProps.filterField"
					[filterFieldValue]="modalProps.filterFieldValue"
					fieldNameInItemToDisplay="contactway"
					isCheckItems
					[filterFieldApiObject]="{ contactway_identifier: 'email' }"
				/>
			</app-modal-wrap>
		}
	`,
})
export class ChoosePersonComponent extends Modalable {
	modalProps: any = null
	async handleChoose(obj: any = null) {
		if (!obj?.id) {
			return
		}
		const filterField = `${obj.typeClassName.slice(0, -1)}_id`
		this.modalProps = { filterField, filterFieldValue: obj.id }
	}
}
